<template>
  <div class="vc-tutorial__layout">
    <transition name="fade">
      <div v-if="isModalVisible" class="vc-tutorial__overlay"></div>
    </transition>

    <transition name="fade">
      <div v-if="isModalVisible" class="vc-tutorial__modal">
        <span class="vc-tutorial__modal-close" @click="closeModal">×</span>
        <slot></slot>
      </div>
    </transition>

    <div class="vc-tutorial__button">
      <div class="vc-tutorial__button-label">Passo a passo</div>
      <div class="vc-tutorial__button-icon" @click="openModal">
        <vc-material-icon
          icon="question_mark"
          style="font-size: 14px"
        ></vc-material-icon>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { provide, ref, watch } from "vue";

const props = defineProps<{
  defaultOpen?: string;
}>();

const emit = defineEmits<{
  (e: string): void;
}>();

const isModalVisible = ref(false);

provide("isModalVisible", isModalVisible);

const openModal = () => {
  isModalVisible.value = true;
};

const closeModal = () => {
  isModalVisible.value = false;

  emit("close");
};

watch(
  () => props.defaultOpen,
  () => {
    const isDefaultOpen =
      props.defaultOpen && /^true$/i.test(props.defaultOpen);

    if (isDefaultOpen) {
      openModal();
    }
  }
);
</script>

<style scoped lang="scss">
.vc-tutorial {
  &__layout {
    text-align: right;
  }

  &__button {
    background: transparent;
    padding: 4px 0px 4px 3px;
    border-radius: 5px;
    width: 130px;
    height: 22px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    align-items: center;

    transition: 0.2s;

    &-label {
      font-size: 14px;
      line-height: 24px;
      font-weight: 700;
      color: _map.get($map: $neutro, $key: 950);
      opacity: 0;
      word-wrap: normal;
      white-space: nowrap;

      opacity: 0;
      transform: translateX(-20px);
      transition: transform 0.3s ease, opacity 0.3s ease;
    }

    &:hover {
      background: _map.get($map: $azulSecundario, $key: 100);
      padding: 4px 0px 4px 3px;

      .vc-tutorial__button-label {
        opacity: 1;
        transform: translateX(0);
        transition: transform 0.3s ease, opacity 0.3s ease;
        display: block;
      }
    }

    &-icon {
      width: 24px;
      height: 23px;
      color: _map.get($map: $azulSecundario, $key: 800);
      background-color: _map.get($map: $neutro2, $key: 50);
      border: 1px solid _map.get($map: $azulSecundario, $key: 800);
      text-align: center;
      line-height: 25px;
      border-radius: 2px;
      cursor: pointer;
      transition: 0.2s;

      &:hover {
        background-color: _map.get($map: $azulSecundario, $key: 50);
      }
    }
  }

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10000;
  }

  &__modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: _map.get($map: $neutro2, $key: 50);
    padding: 20px;
    border-radius: 5px;
    width: 1000px;
    max-width: 90%;
    z-index: 10001;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    &-close {
      position: absolute;
      top: 17px;
      right: 27px;
      background: transparent;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: _map.get($map: $neutro, $key: 700);
    }

    &-content {
      padding: 20px;
      font-size: 16px;
      color: _map.get($map: $neutro, $key: 950);
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
